module.exports = __webpack_public_path__ + "img/logo.285d0017.png";